<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <v-row>
    <v-dialog
      v-model="dialog2"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 primary">
          <v-btn
            icon
            dark
            @click="dialog2 = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>  Choose {{ open_service }}
        </v-card-title>
        <v-card-text class="pt-4">
          <GetService_other v-if="open_service =='Other'"></GetService_other>
          <GetGuide v-if="open_service =='Guide'"></GetGuide>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog2 = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col>
      <v-simple-table>
        <thead class="font-weight-bold">
          <tr>
            <td width="300">
              Guide
            </td>
            <td>Cost</td>
            <td colspan="2">
              Duration
            </td>

            <td>Total</td>
            <td>Per Pax</td>
          </tr>
        </thead>
        <tbody v-if="!travelcost.record_guide.description">
          <tr>
            <td>
              <v-text-field
                v-model="travelcost.record_guide.description"
                hide-details
                dense
                solo
                placeholder="Choose Guide"
                label="Choose Guide"
                outlined
                @click="OpenService('Guide')"
              />
            </td>
            <td>
              <v-currency-field
                v-model="travelcost.record_guide.cost"
                prefix="Rp."
                type="number"
                hide-details
                dense
                solo
                placeholder="Cost"
                label="Cost"
                outlined
                @change="ChangeTotalGuide()"
              />
            </td>
            <td>
              <v-text-field
                v-model="travelcost.record_guide.duration"
                type="number"
                hide-details
                dense
                solo
                placeholder="Duration"
                label="Duration"
                outlined
              />
            </td>

            <td colspan="2">
              <v-currency-field
                v-model="travelcost.record_guide.duration.total"
                prefix="Rp."
                readonly
                hide-details
                dense
                solo
                placeholder="Total"
                label="Total"
                outlined
              />
            </td>
            <td>
              <v-currency-field
                v-model="travelcost.record_guide.per_pax"
                prefix="Rp."
                readonly
                hide-details
                dense
                solo
                placeholder="Per Pax"
                label="Per Pax"
                outlined
              />
            </td>
          </tr>
        </tbody>
        <tbody v-if="travelcost.record_guide.description">
          <tr>
            <td>{{ travelcost.record_guide.description }}</td>
            <td>Rp. {{ Number(travelcost.record_guide.cost).toLocaleString() }}</td>
            <td>
              <v-text-field
                v-model="travelcost.record_guide.duration"
                type="number"
                hide-details
                dense
                solo
                placeholder="Qty"
                label="Qty"
                outlined
                @change="ChangeTotalGuide()"
              />
            </td>
            <td colspan="2">
              Rp. {{ Number(travelcost.record_guide.total).toLocaleString() }}
            </td>
            <td>Rp. {{ Number(travelcost.record_guide.per_pax).toLocaleString() }}</td>
            <td>
              <v-btn
                small
                class="error"
                @click="DeleteRecordGuide()"
              >
                <v-icon>{{ icons.mdiTrashCan }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-simple-table class="mt-5">
        <thead class="font-weight-bold">
          <tr>
            <td width="300">
              Description
            </td>
            <td>Cost</td>
            <td width="90">
              Qty
            </td>
            <td width="90">
              Nt
            </td>
            <td>Total</td>
            <td>Per Pax</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <v-text-field
                v-model="recordtravelcost.description"
                hide-details
                dense
                solo
                placeholder="Description"
                label="Description"
                outlined
                @click="OpenService('Other')"
              />
            </td>
            <td>
              <v-currency-field
                v-model="recordtravelcost.cost"
                prefix="Rp."
                type="number"

                hide-details
                dense
                solo
                placeholder="Cost"
                label="Cost"
                outlined
                @change="ChangeTotal()"
              />
            </td>
            <td>
              <v-text-field
                v-model="recordtravelcost.qty"
                type="number"
                hide-details
                dense
                solo
                placeholder="Qty"
                label="Qty"
                outlined
                @change="ChangeTotal()"
              />
            </td>
            <td>
              <v-text-field
                v-model="recordtravelcost.nt"
                type="number"
                hide-details
                dense
                solo
                placeholder="Nt"
                label="Nt"
                outlined
                @change="ChangeTotal()"
              />
            </td>
            <td>
              <v-currency-field
                v-model="recordtravelcost.total"
                prefix="Rp."
                readonly
                hide-details
                dense
                solo
                placeholder="Total"
                label="Total"
                outlined
              />
            </td>
            <td>
              <v-currency-field
                v-model="recordtravelcost.per_pax"
                prefix="Rp."
                readonly
                hide-details
                dense
                solo
                placeholder="Per Pax"
                label="Per Pax"
                outlined
              />
            </td>
            <td>
              <v-btn
                small
                class="primary"
                @click="AddCostTravel()"
              >
                Add
                <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td
              colspan="7 "
              class="text-h6 font-weight-bold"
            >
              Variable Cost
            </td>
          </tr>
          <tr
            v-for="(tc,index) in travelcost.detailvarcost"
            :key="tc.id_other"
          >
            <td>{{ tc.description }}</td>
            <td>Rp. {{ Number(tc.cost).toLocaleString() }}</td>
            <td>
              <v-text-field
                v-model="travelcost.detailvarcost[index].qty"
                type="number"
                hide-details
                dense
                solo
                placeholder="Qty"
                label="Qty"
                outlined
                @change="ChangeTotalInputVarCost(index)"
              />
            </td>
            <td>
              <v-text-field
                v-model="travelcost.detailvarcost[index].nt"
                type="number"
                hide-details
                dense
                solo
                placeholder="Qty"
                label="Qty"
                outlined
                @change="ChangeTotalInputVarCost(index)"
              />
            </td>
            <td>
              Rp. {{ Number(tc.total).toLocaleString() }}
            </td>
            <td>Rp. {{ Number(tc.per_pax).toLocaleString() }}</td>
            <td>
              <v-btn
                small
                class="error"
                @click="DeleteVarCost(index)"
              >
                <v-icon>{{ icons.mdiTrashCan }}</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr>
            <td
              colspan="7 "
              class="text-h6 font-weight-bold"
            >
              Fix Cost
            </td>
          </tr>
          <tr
            v-for="(tc,index1) in travelcost.detailfixcost"
            :key="tc.id_other"
          >
            <td>{{ tc.description }}</td>
            <td>Rp. {{ Number(tc.cost).toLocaleString() }}</td>
            <td>
              <v-text-field
                v-model="travelcost.detailfixcost[index1].qty"
                type="number"
                hide-details
                dense
                solo
                placeholder="Qty"
                label="Qty"
                outlined
                @change="ChangeTotalInputFixCost(index1)"
              />
            </td>
            <td>
              <v-text-field
                v-model="travelcost.detailfixcost[index1].nt"
                type="number"
                hide-details
                dense
                solo
                placeholder="Qty"
                label="Qty"
                outlined
                @change="ChangeTotalInputFixCost(index1)"
              />
            </td>
            <td>
              Rp. {{ Number(tc.total).toLocaleString() }}
            </td>
            <td>Rp. {{ Number(tc.per_pax).toLocaleString() }}</td>
            <td>
              <v-btn
                small
                class="error"
                @click="DeleteFixCost(index1)"
              >
                <v-icon>{{ icons.mdiTrashCan }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>
<script>
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

// eslint-disable-next-line camelcase
import axios from 'axios'
// eslint-disable-next-line camelcase
import GetService_other from '../get-data/get-service_other.vue'
import GetGuide from '../get-data/get-guide.vue'

export default {
  components: { GetService_other, GetGuide },
  props: ['datainvoice'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      dialog2: false,
      travelcost: {
        record_guide: {
          id_guide: '',
          description: '',
          cost: '',
          duration: this.datainvoice.total_day,
          total: '',
          per_pax: '',
        },
        fixcost: 0,
        varcost: 0,
        detailvarcost: [],
        detailfixcost: [],
      },
      recordtravelcost: {
        id_other: '',
        description: '',
        duration: 0,
        cost: '',
        qty: 1,
        nt: 1,
        total: '',
        per_pax: '',
      },
      open_service: '',
    }
  },
  mounted() {
    this.$root.$on('BuatTravelCost', (data, type) => {
      this.AddCostVariable(data, type)
      this.dialog2 = false
    })
  },
  created() {

  },
  methods: {
    Update() {
      if (this.$route.query.id_tour) {
        this.getDataEditTour()
      } else {
        this.ChangeQty()
      }
    },
    ChangeQty() {
      // eslint-disable-next-line radix
      this.travelcost.record_guide.duration = this.datainvoice.total_day

      // eslint-disable-next-line radix
      this.travelcost.record_guide.per_pax = parseInt(Math.round(this.travelcost.record_guide.total / this.datainvoice.total_adult))

      this.travelcost.detailvarcost.forEach((element, index) => {
      // eslint-disable-next-line radix
        this.travelcost.detailvarcost[index].per_pax = Math.round(parseInt(this.travelcost.detailvarcost[index].total) / parseInt(this.datainvoice.total_adult))
      })

      this.travelcost.detailfixcost.forEach((element, index) => {
      // eslint-disable-next-line radix
        this.travelcost.detailfixcost[index].per_pax = Math.round(parseInt(this.travelcost.detailfixcost[index].total) / parseInt(this.datainvoice.total_pax))
      })
      this.CountCostTravel()
      this.ChangeTotalGuide()
    },
    getDataEditTour() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getDataEditTourVariableCost', { id_tour: this.$route.query.id_tour }).then(response => {
        if (response.data.data.record_guide !== null) {
          this.travelcost.record_guide = response.data.data.record_guide
        }
        if (response.data.data.detailvarcost.length > 0) {
          this.travelcost.detailvarcost = response.data.data.detailvarcost
        }
        if (response.data.data.detailfixcost.length > 0) {
          this.travelcost.detailfixcost = response.data.data.detailfixcost
        }

        this.CountCostTravel()
        this.$root.$emit('CountPerpax')
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
      }).catch(err => {
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
        this.isLoading = false
      })
    },
    DeleteRecordGuide() {
      this.travelcost.record_guide = {
        id_guide: '',
        description: '',
        cost: 0,
        duration: this.datainvoice.total_day,
        total: 0,
        per_pax: 0,
      }
      this.CountCostTravel()
    },
    OpenService(nameservice) {
      this.open_service = nameservice
      this.dialog2 = true
    },
    AddCostVariable(data, type) {
      if (type === 'Other') {
        this.recordtravelcost.id_other = data.id_other
        this.recordtravelcost.type = type
        this.recordtravelcost.description = data.other_name
        this.recordtravelcost.category = data.category
        // eslint-disable-next-line radix
        this.recordtravelcost.cost = parseInt(Math.round(parseInt(data.rate)))
      }
      if (type === 'Guide') {
        this.travelcost.record_guide.description = `Guide - ${data.guide_name}`
        this.travelcost.record_guide.id_guide = data.id_guide
        this.travelcost.record_guide.cost = data.rate
        this.travelcost.record_guide.duration = this.datainvoice.total_day
        this.travelcost.record_guide.total = this.datainvoice.total_day * data.rate
        // eslint-disable-next-line radix
        this.travelcost.record_guide.per_pax = parseInt(Math.round(this.travelcost.record_guide.total / this.datainvoice.total_adult))
      }
      this.ChangeTotal()
    },
    DeleteVarCost(index) {
      //  this.travelcost.details.splice(this.travelcost.details.indexOf(index), 1)
      this.$delete(this.travelcost.detailvarcost, index)
      this.CountCostTravel()
    },
    DeleteFixCost(index) {
      //  this.travelcost.details.splice(this.travelcost.details.indexOf(index), 1)
      this.$delete(this.travelcost.detailfixcost, index)
      this.CountCostTravel()
    },
    ChangeTotalGuide() {
      // eslint-disable-next-line radix
      this.travelcost.record_guide.total = parseInt(this.travelcost.record_guide.cost) * parseInt(this.travelcost.record_guide.duration)
      // eslint-disable-next-line radix
      this.travelcost.record_guide.per_pax = Math.round(parseInt(this.travelcost.record_guide.total) / parseInt(this.datainvoice.total_adult))
      this.CountCostTravel()
    },
    ChangeTotal() {
      if (this.recordtravelcost.qty < 1 || this.recordtravelcost.nt < 1) {
        this.recordtravelcost.qty = 1
        this.recordtravelcost.nt = 1
        // eslint-disable-next-line radix
        this.recordtravelcost.total = parseInt(this.recordtravelcost.cost) * parseInt(this.recordtravelcost.qty) * parseInt(this.recordtravelcost.nt)
        this.$root.$emit('PesanResponse', 'Minimal Qty dan Nt 1', 'red')
        // eslint-disable-next-line radix
      } else {
        // eslint-disable-next-line radix
        this.recordtravelcost.total = parseInt(this.recordtravelcost.cost) * parseInt(this.recordtravelcost.qty) * parseInt(this.recordtravelcost.nt)
        // eslint-disable-next-line radix
      }

      if (this.recordtravelcost.category === 'Variable Cost') {
        // eslint-disable-next-line radix
        this.recordtravelcost.per_pax = Math.round(parseInt(this.recordtravelcost.total) / parseInt(this.datainvoice.total_adult))
      } else {
        // eslint-disable-next-line radix
        this.recordtravelcost.per_pax = Math.round(parseInt(this.recordtravelcost.total) / parseInt(this.datainvoice.total_pax))
      }
      this.CountCostTravel()
    },
    ChangeTotalInputVarCost(index) {
      if (this.travelcost.detailvarcost[index].qty < 1 || this.travelcost.detailvarcost[index].nt < 1) {
        this.travelcost.detailvarcost[index].qty = 1
        this.travelcost.detailvarcost[index].nt = 1
        this.travelcost.detailvarcost[index].total = this.travelcost.detailvarcost[index].cost * this.travelcost.detailvarcost[index].qty * this.travelcost.detailvarcost[index].nt
        this.$root.$emit('PesanResponse', 'Minimal Qty dan Nt 1', 'red')
      } else {
        this.travelcost.detailvarcost[index].total = this.travelcost.detailvarcost[index].cost * this.travelcost.detailvarcost[index].qty * this.travelcost.detailvarcost[index].nt
        this.travelcost.detailvarcost[index].per_pax = Math.round(this.travelcost.detailvarcost[index].total / this.datainvoice.total_adult)
      }
      this.CountCostTravel()
    },
    ChangeTotalInputFixCost(index) {
      if (this.travelcost.detailfixcost[index].qty < 1 || this.travelcost.detailfixcost[index].nt < 1) {
        this.travelcost.detailfixcost[index].qty = 1
        this.travelcost.detailfixcost[index].nt = 1
        this.travelcost.detailfixcost[index].total = this.travelcost.detailfixcost[index].cost * this.travelcost.detailfixcost[index].qty * this.travelcost.detailfixcost[index].nt
        this.$root.$emit('PesanResponse', 'Minimal Qty dan Nt 1', 'red')
      } else {
        this.travelcost.detailfixcost[index].total = this.travelcost.detailfixcost[index].cost * this.travelcost.detailfixcost[index].qty * this.travelcost.detailfixcost[index].nt
        this.travelcost.detailfixcost[index].per_pax = Math.round(this.travelcost.detailfixcost[index].total / this.datainvoice.total_pax)
      }
      this.CountCostTravel()
    },
    AddCostTravel() {
      if (!this.recordtravelcost.category) {
        this.$root.$emit('PesanResponse', 'Please Choose Variable Cost', 'red')
      } else {
        if (this.recordtravelcost.category === 'Variable Cost') {
          this.travelcost.detailvarcost.push(this.recordtravelcost)
        } else {
          this.travelcost.detailfixcost.push(this.recordtravelcost)
        }
        this.recordtravelcost = {
          id_other: '',
          category: '',
          description: '',
          cost: '',
          qty: 1,
          nt: 1,
          total: '',
          per_pax: '',
        }
      }
      this.CountCostTravel()
    },
    CountCostTravel() {
      let fixcost = 0
      let varcost = 0

      this.travelcost.detailvarcost.forEach(number => {
        // eslint-disable-next-line no-const-assign
        varcost += number.per_pax
      })
      this.travelcost.detailfixcost.forEach(number => {
        fixcost += number.per_pax
      })

      this.travelcost.fixcost = fixcost

      this.travelcost.varcost = varcost
      this.$root.$emit('CountPerpax')
    },
  },
}
</script>
